import { ReactNode } from 'react';
import { classNames } from '@progress/kendo-react-common';
import styles from './FlexGrid.module.scss';

export type FlexGridProps = {
    children?: ReactNode,
    className?: string
};

export const FlexGrid = ({ children, className }: FlexGridProps) => (
    <div className={classNames(styles.grid, className)}>
        {children}
    </div>
);

export type FlexGridItemProps = {
    children?: ReactNode,
    label: ReactNode | string,
    labelClassName?: string,
    value: ReactNode | string,
    valueClassName?: string
} & FlexGridProps;

export const FlexGridItem = ({ children, label, labelClassName, value, valueClassName }: FlexGridItemProps) =>
    children ?
        <>{children}</>
    : (
        <>
            <FlexGridLabel className={labelClassName}>{label}</FlexGridLabel>
            <FlexGridValue className={valueClassName}>{value}</FlexGridValue>
        </>
    );

export const FlexGridLabel = ({ children, className }: FlexGridProps) => (
    <div className={classNames(styles.label, className)}>{children}</div>
);

export const FlexGridValue = ({ children, className }: FlexGridProps) => (
    <div className={classNames(styles.value, className)}>{children}</div>
);
